import React from 'react';
import AboutUsSection from '../unit/unit-section';

const FindCareHow = (props) => {
  const { Translations } = props;

  return (
    <div className="find-care-how">
      {props.Information?.Description && (
        <AboutUsSection>
          <div
            className="find-care-how__information"
            dangerouslySetInnerHTML={{ __html: props.Information.Description }}
          ></div>
        </AboutUsSection>
      )}
      {props.ReferralRequirements && (
        <AboutUsSection Heading={props.Translations?.patientreferral}>
          {props.ReferralRequirements.map((rule, key) => (
            <p style={{ marginBottom: 0 }} key={key}>
              {rule}
            </p>
          ))}
        </AboutUsSection>
      )}
      {props.PatientAge && (
        <AboutUsSection Heading={Translations.age}>
          {props.PatientAge.map((item, index) => (
            <p key={index}>{item.Text}</p>
          ))}
        </AboutUsSection>
      )}
    </div>
  );
};

export default FindCareHow;
